import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import Footer from './Footer'
import ArticleSearch from './ArticleSearch'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

// Firebase
import base from '../base'

class ArticleOnly extends Component {

    state = {
        nameSearch: this.props.match.params.search,
        search: '',
        recettes: [],
        redirect:false
        }
    
    componentDidMount(){
        //reference ds firebase    
        this.ref = base.syncState(`/listeRecettes`,{
          context: this,
          state: 'recettes'
        })
    }
    
    componentWillUnmount () {
        //fermer la reference ds firebase
        //la connexion est terminée entre notre state et firebase
        base.removeBinding(this.ref)
        }
    
        setArticles = () => {
        this.setState({
            redirect: true
        })
        }

        setRedirect = () => {
          this.setState({
            redirect: true
          })
        }
          
        handleSubmitFacebbok = () => {
          if (this.state.redirect) {
              window.location.href = "https://www.facebook.com/clubCAPN/";
          }
        }
        

        handleCHange = event => {
            const { name, value } = event.target
            this.setState({ [name]: value })
        }
        
          handleSubmit = event => {
            //on gere le form
            event.preventDefault()
            this.props.history.push(`/recherche/${this.state.search}`);
        
          }

        render () {  
            let articles = []
            Object
                .entries(this.state.recettes)
                .forEach(key => {
                  console.log(key)
                    if(key[1].nom.includes(this.state.nameSearch))
                    {

                        articles.push(key);
                    }
                }
            );
        return (
            <>
            <Container fluid>
            <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />
    
                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                      <div className="actu-content">
                        <h1 className="hline"><span>Recherche en cours</span></h1> 
                            {((articles.length > 0)) &&
                                <ArticleSearch  details={articles}/>
                            }
                        </div>
                      </Col>
    
    
                  <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                  <div className={articles.length <= 6 ? 'fixed-bottom-footer' : 'fixed-bottom-footer-not'}><Footer /></div>
                  </Col>
                </Col>
              </Row>
            </Container>
          </>
        )
    }
}
export default ArticleOnly;